var _rect, _rect2, _path, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImpactHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "59.31 0.22 165.05 165.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "paint3",
    x: 70.6895,
    y: 82.7393,
    width: 100.614,
    height: 100.614,
    rx: 50.3071,
    transform: "rotate(-45 70.6895 82.7393)",
    fill: "url(#paint0_linear_6_690)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "paint2",
    x: 83.4004,
    y: 82.7393,
    width: 82.6407,
    height: 82.6407,
    rx: 41.3204,
    transform: "rotate(-45 83.4004 82.7393)",
    stroke: "#1A2024",
    strokeWidth: 1.03582
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "paint1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.421 71.1533L135.229 76.2373L140.703 66.6904L138.741 63.2763C137.737 61.6648 136.369 61.2002 134.863 61.2002C133.128 61.2002 131.715 61.9993 130.985 63.2763L126.421 71.1533ZM151.838 63.2789C150.972 61.7205 149.601 61.3409 148.597 61.2958L138.332 61.2506C139.107 61.6675 139.609 62.3232 140.066 63.0984L145.36 72.2895L142.393 73.978L152.659 74.7612L157.132 65.5117L154.12 67.2453L151.838 63.2789ZM149.328 79.1205L154.85 88.6833H158.821C162.152 88.5001 163.201 85.224 163.201 83.947C163.201 83.2621 163.018 82.5798 162.654 81.9479L158.09 74.0417L149.328 79.1205ZM119.486 76.24L122.498 77.9895L120.217 81.9957C119.805 82.6727 119.624 83.3098 119.624 83.9045C119.624 84.6346 119.853 85.2718 120.081 85.7284L125.237 94.6593C125.192 93.7939 125.51 93.0186 125.967 92.2434L131.261 83.0842L134.228 84.7727L129.755 75.5072L119.486 76.24ZM147.686 86.4479L141.891 94.9301L147.641 103.458V99.9903H152.25C154.029 100.035 154.988 99.0319 155.58 98.2115L160.736 89.3178C160.006 89.7744 159.185 89.8647 158.271 89.8647H147.684V86.4479H147.686ZM126.743 93.2894C126.379 94.0195 126.196 94.7045 126.196 95.3416C126.196 97.3036 127.93 99.993 130.621 99.993H139.747V89.8673H128.703L126.743 93.2894Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "paint0",
    id: "paint0_linear_6_680",
    x: 59.8262,
    y: 82.7393,
    width: 115.974,
    height: 115.974,
    rx: 57.9871,
    transform: "rotate(-45 59.8262 82.7393)",
    stroke: "#E7FF00",
    strokeWidth: 1.03582
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    className: "paint0",
    id: "paint0_linear_6_690",
    x1: 120.997,
    y1: 82.7393,
    x2: 120.997,
    y2: 183.353,
    gradientUnits: "userSpaceOnUse",
    fill: "transparent !important"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FF00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D428"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactHome);
export default __webpack_public_path__ + "static/media/Impact_home.fbac4d96b3738c1a4d811522bf466915.svg";
export { ForwardRef as ReactComponent };